module.exports = __webpack_public_path__ + "static/img/jp1.65a79e04.png";